import * as Font from 'expo-font';

export const initExpoFonts = async (cachedFonts?: Record<string, string>): Promise<void> => {
  return Font.loadAsync({
    ...(cachedFonts || {}),
  });
};
